// extracted by mini-css-extract-plugin
export var footerNavigation = "footerNavigation-module--footerNavigation--1UqmL";
export var logoWrap = "footerNavigation-module--logoWrap--1WFk1";
export var logo = "footerNavigation-module--logo--3z__3";
export var list = "footerNavigation-module--list--2n2U-";
export var listItem = "footerNavigation-module--listItem--3z_q6";
export var listLink = "footerNavigation-module--listLink--1bgzz";
export var sublistItem = "footerNavigation-module--sublistItem--3zqP-";
export var sublistLink = "footerNavigation-module--sublistLink--d4MPY";